import React from "react"
import FieldProto from "../../proto/field-proto";

export type FieldGlistViewProps = {
    field       : FieldProto
    model       : any,
    module      : any   // in this case this is glist !
};

export default function FieldGlistView(props:FieldGlistViewProps):React.ReactElement {
    return <props.field.renderComponents.glistView {...props} />

}
